import { Component } from '@angular/core';

/** Três pontinhos de "digitando" da IA. */
@Component({
    selector: 'ra-chat-typing',
    template: `<span></span><span></span><span></span>`,
    host: { class: 'ra-chat-typing', role: 'presentation' },
    styles: `
        :host {
            display: flex;
            gap: 0.3125rem;
            padding: 0.5rem 0;
        }

        span {
            width: 0.4375rem;
            height: 0.4375rem;
            border-radius: 50%;
            background: var(--contentTertiary);
            animation: typing-blink 1s infinite ease-in-out;
        }

        span:nth-child(2) {
            animation-delay: 0.15s;
        }

        span:nth-child(3) {
            animation-delay: 0.3s;
        }

        @keyframes typing-blink {
            50% {
                opacity: 0.35;
                transform: translateY(-0.125rem);
            }
        }

        @media (prefers-reduced-motion: reduce) {
            span {
                animation: none;
            }
        }
    `,
})
export class RaChatTypingComponent {}
